import { Segmented } from "antd";
import TaxFlow, { TabPaneTitle } from "./taxFlow";
import TaxCaseStore from "../../../../contexts/taxCaseStore";
import format from "../../../../utilities/formatNumbers";
import _t from "../../../../lang/translate";
import { useState } from "react";

type Mode = "offer" | "optimization";
export default function TaxFlowWraper() {

  const { taxCase } = TaxCaseStore.useContainer();

  const { offer, optimization } = taxCase.scenarios;

  const offerRegFee = offer?.calculation?.registrationFee?.registrationFee ?? null;
  const optimizationRegFee =
    optimization?.calculation?.registrationFee?.registrationFee ?? null;

  const [mode, setMode] = useState<Mode>(
    taxCase.flags.accepted ? "optimization" : "offer"
  );

  return (
    <>
      <Segmented block onChange={(v) => setMode(v as Mode)} value={mode}
        className="tax-flow-wrapper-segmented mb-1"
        options={[
          {
            value: 'offer',
            label: <TabPaneTitle text={_t("preassessment")} price={offerRegFee ?? null} />
          },
          {
            value: 'optimization',
            label: <TabPaneTitle text={_t("evaluation")} price={optimizationRegFee ?? null} />
          }

        ]}
      />
      <div style={{ display: mode === 'offer' ? "block" : "none" }}>
        <TaxFlow optMode={false} />
      </div>
      <div style={{ display: mode === 'optimization' ? "block" : "none" }}>
        <TaxFlow optMode={true} />
      </div>
    </>

  )
}
